import { useCallback, useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { sendRequest } from '../requests/useRequest';
import { useForm } from '../forms/useForm';
import { validarSesion } from '../tokens/useToken';
import { usePagination } from '../pagination/usePagination';

export const useRack = ({activeTab}) => {

    const history = useHistory();
    const [racks, setRacks] = useState([]);
    const [idRack, setIdRack] = useState(0);

    const [modal, setModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");
    const [method, setMethod] = useState("");

    const [createSweet] = useSweetAlert();
    const [loading, setLoading] = useState(false);


    const [modalAlert, setModalAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);


    const [loadingExcel, setLoadingExcel] = useState(false);
    const [searchRack, setSearchRack] = useState("");
    const [rackData, setRackData] = useState([]);

    const [formValues, handleInputChange, reset, handleUpdateValues] = useForm({
        name: "",
        code: "",
        slots: 0,
    });

    const { name, code, slots } = formValues;

    const [validaciones, setValidaciones] = useState({
        name_valid: false,
        code_valid: false,
        slots_valid: false
    });

    const numberItems = 5;
    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(racks.length, numberItems);

    useEffect(() => {
        let startItems = 0;
        let endItems = numberItems;

        let aux = numberItems * currentPage;

        endItems = aux;

        startItems = endItems - numberItems;
        let listRacks = [];
        racks.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listRacks.push({
                ...data,
                visibleTable: visibleTable
            });
        });

        setRacks(listRacks);
    }, [totalPageCount, currentPage])

    const openDialog = (title, mode) => {
        // setModalTitle(title);
        setMethod(mode);
        setModal(true);
    };

    const closeDialog = () => {
        setModal(false);
    };

    const openDeleteAlert = () => {
        setShowDeleteAlert(true); 
        setModalAlert(true);  
    };

    const closeDeleteAlert = () => {
        setModalAlert(false);   
    };

    const getRacks = async () => {
        let requestOptions = {
            method: 'GET'
        };

        let listRacks = [];

        const respuesta = await sendRequest(requestOptions, "Rack/List");

        if (respuesta.code === 200) {

            if (respuesta.data.length >= 1) {

                let startItems = 0;
                let endItems = numberItems;
                let aux = numberItems * currentPage;

                endItems = aux;

                startItems = endItems - numberItems;

                respuesta.data.forEach((obj, index) => {

                    let posicion = index + 1;
                    let visibleTable = false;

                    if (posicion > startItems && posicion <= endItems) {
                        visibleTable = true;
                    }

                    listRacks.push({
                        ...obj,
                        visibleTable: visibleTable
                    });
                });

                setRacks(listRacks);
                setRackData(listRacks);
            }
            else {
                setRacks([]);
            }
        }
        else {
            validarSesion(history, getRacks);
        }
    }

    useEffect(() => {
        if (activeTab === 2) {
            getRacks();
        }
    }, [activeTab]);
    

    useEffect(() => {
        getRacks();
    }, [history.location])

    const handleCreate = () => {
        handleUpdateValues({
            name: "",
            code: "",
            slots: 0,
        });

        setValidaciones({
            name_valid: false,
            code_valid: false,
            slots_valid: false,
        });

        setIdRack(0);
        setMethod("create");
        setModalTitle("Creación de gradilla");
        openDialog("Crear gradilla", "create");
    }

    const saveCreate = async (e) => {
        e.preventDefault();

        if (validarForm()) {
            return;
        }

        setLoading(true);

        let data = JSON.stringify(formValues);

        let requestOptions = {
            method: 'POST',
            body: data
        };

        const respuesta = await sendRequest(requestOptions, "Rack");

        if (respuesta.code === 200) {
            setLoading(false);
            createSweet("create", "success", "Exito!", "Se creo correctamente");
            closeDialog();
            getRacks();
            handleUpdateValues({
                name: "",
                code: "",
                slots: 0,
            });
        }
        else {
            setLoading(false);
            validarSesion(history, handleCreate);
        }

    }

    const handleUpdate = (id_rack) => {
        let rack = racks.find(x => x.id_rack === parseInt(id_rack));

        handleUpdateValues({
            name: rack.name,
            code: rack.code,
            slots: rack.slots,
        });

        setValidaciones({
            name_valid: false,
            code_valid: false,
            slots_valid: false,
        });

        setIdRack(id_rack);
        setMethod("update");
        setModalTitle("Actualizar gradilla");
        openDialog("actualizar gradilla", "update");
    }

    const saveUpdate = async (e) => {
        e.preventDefault();

        if (validarForm()) {
            return;
        }

        setLoading(true);

        let mValues = {
            id_rack: idRack,
            ...{ ...formValues }
        };

        let data = JSON.stringify(mValues);
        let requestOptions = {
            method: 'PUT',
            body: data
        };

        const respuesta = await sendRequest(requestOptions, "Rack/Update");

        if (respuesta.code === 200) {
            getRacks();
            createSweet("update", "info", "Exito!", "Se actualizo la gradilla");
            setLoading(false);
            closeDialog();
        }
        else {
            validarSesion(history, saveUpdate);
        }
    }

    const handleDelete = (id_rack) => {
        let rack = racks.find(x => x.id_rack === parseInt(id_rack));

        handleUpdateValues({
            name: rack.name,
            code: rack.code,
            slots: rack.slots,
        });

        setIdRack(id_rack);
        setMethod("delete");
        setModalTitle("Eliminar gradilla");
        openDeleteAlert();
    }

    const saveDelete = async (e) => {
        e.preventDefault();

        setLoading(true);

        let requestOptions = {
            method: 'DELETE'
        };

        const respuesta = await sendRequest(requestOptions, `Rack/${idRack}`);
        if (respuesta.code === 200) {
            getRacks();
            setLoading(false);
            createSweet("delete", "success", "Exito!", "Se elimino correctamente");
            closeDeleteAlert();
        }
        else {
            validarSesion(history, saveDelete);
        }
    }

    const validarForm = () => {
        let statusValidacion = false;
        let newValidaciones = {};

        if (formValues.name === "" || formValues.name.length < 2) {
            newValidaciones = {
                ...newValidaciones,
                name_valid: true
            };

            statusValidacion = true;
        }
        else {
            newValidaciones = {
                ...newValidaciones,
                name_valid: false
            };
        }

        if (formValues.code === "" || formValues.code.length < 2) {
            newValidaciones = {
                ...newValidaciones,
                code_valid: true
            };

            statusValidacion = true;
        }
        else {
            newValidaciones = {
                ...newValidaciones,
                code_valid: false
            };
        }

        if (formValues.slots === "" || formValues.slots <= 1) {
            newValidaciones = {
                ...newValidaciones,
                slots_valid: true
            };

            statusValidacion = true;
        }
        else {
            newValidaciones = {
                ...newValidaciones,
                slots_valid: false
            };
        }

        setValidaciones(newValidaciones);

        return statusValidacion;
    }

    const handleSearchRack = (value) => {

        let busqueda = value;

        setSearchRack(busqueda);

        if (!busqueda || busqueda.trim() === "") {
            setRacks(rackData);
            return;
        }

        let newRack = rackData.filter((element) => {

            return (
                element.name?.toUpperCase().includes(busqueda.toUpperCase()) ||
                element.code?.toUpperCase().includes(busqueda.toUpperCase()) ||
                element.slots?.toString().includes(busqueda)
            );
        });

        setRacks(newRack);
    }

    const handleClearRack = () => {
        setSearchRack("");
        setRacks(rackData);
    }

    const handleExcelRack = async () => {
        setLoadingExcel(true);
        try {
            const XLSX = await import("xlsx");
            const _report = rackData.map((item, index) => ({
                "#": index + 1,
                Nombre: item.name ?? "---",
                Código: item.code ?? "---",
                Espacios: item.slots ?? "---",
            }));

            const worksheet = XLSX.utils.json_to_sheet(_report);
            const workbook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet( workbook, worksheet, "Gradillas");

            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array"});

            const dataBlob = new Blob(
                [excelBuffer],
                {
                    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                }
            );

            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "catalogo_gradillas.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error al exportar Excel", error);
        }
        setLoadingExcel(false);
    }

    return {
        racks, method,
        name, code, slots, handleInputChange, validaciones,
        closeDialog, modal, modalTitle, loading,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        handleClearRack, searchRack,
        handleSearchRack, loadingExcel,
        handleExcelRack, showDeleteAlert, 
        closeDeleteAlert, modalAlert
    }
}
